import { render } from "./TheUserCreation.vue?vue&type=template&id=6b3f4fd0"
import script from "./TheUserCreation.vue?vue&type=script&lang=js"
export * from "./TheUserCreation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__